import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Haga clic en el botón de abajo para revisar y confirmar su información de pago.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Trabajamos con Stripe para gestionar los pagos. Stripe es la plataforma de pago más segura utilizada por las mayores empresas del mundo.',
      form: {
        terms_acceptance: {
          label:
            'Al continuar, acepta nuestro <FoodAmigosTerms>Acuerdo de Servicios</FoodAmigosTerms> y el <StripeTerms>Acuerdo de Cuenta Conectada de Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe ha marcado información del cliente como faltante o inválida. Corrija los siguientes errores haciendo clic en el botón «Abrir perfil de Stripe»:',
        errors: 'Errores',
        awaiting_verification: 'Tu cuenta de Stripe está siendo verificada',
        awaiting_verification_description:
          'Estamos esperando que Stripe termine de verificar tu negocio. Puedes revisar tu perfil mientras tanto.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Trabajamos con Adyen para gestionar los pagos. Adyen es una de las plataformas de pago más seguras, utilizada por las mayores empresas del mundo.',
    },
  },
  labels: {
    verified: 'Tu cuenta de {{paymentGateway}} está verificada',
    verified_description:
      'La verificación de {{paymentGateway}} está completa. Aún puedes gestionar tu perfil si lo necesitas.',
  },
  buttons: {
    proceed: 'Confirmar mi información de pago',
    copy_link: 'Copiar enlace',
  },
  toasts: {
    something_went_wrong: 'Algo salió mal, contacta con el soporte técnico',
  },
};
